import { useState } from "react";
import LastMenu from "./LastMenu";

import Mainmenu from "./MainMenu";
import you from '../../assets/images/boy.png'

import bot from '../../assets/images/happy.png'; 
import ApplicationAssist from "./ApplicationAssist";

const Admissions = () =>{

    const [showMenu, setShowMenu] = useState(true);
    const [showFrame1, setShowFrame1] = useState(false);
    const [showFrame2, setShowFrame2] = useState(false);
    const [showFrame3, setShowFrame3] = useState(false);
    const [showFrame4, setShowFrame4] = useState(false);
    const [showFrame5, setShowFrame5] = useState(false);

    
      const [time, setTime] = useState(new Date());

    return (
        <>
            <div className="frame1 animated-frame">
            What do you want to know more about?
            </div>
            {showMenu &&
                <div className="menu-btns animated-frame">
                <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(true);
                        setShowFrame2(false);
                        setShowFrame3(false);
                        setShowFrame4(false);
                        setShowFrame5(false);
                    }}
                >Admissions Requirements</button>
                <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(false);
                        setShowFrame2(true);
                        setShowFrame3(false);
                        setShowFrame4(false);
                        setShowFrame5(false);
                    }}
                >Visa Requirements</button>
                <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(false);
                        setShowFrame2(false);
                        setShowFrame3(true);
                        setShowFrame4(false);
                        setShowFrame5(false);
                    }}
                >Application Process</button>
                <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(false);
                        setShowFrame2(false);
                        setShowFrame3(false);
                        setShowFrame4(true);
                        setShowFrame5(false);
                    }}
                >Application Assistance</button>
                <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(false);
                        setShowFrame2(false);
                        setShowFrame3(false);
                        setShowFrame4(false);
                        setShowFrame5(true);
                    }}
                >Restart the chat</button>
            </div>}

            {showFrame1 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                    <div className="frame2 animated-frame">
                    Admissions Requirements
                    </div>
                    </div>

                    <div className='chatbot'>
                    <img src={bot} alt="bot" className="bot" />
                    <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                    </div>
                    <div className="frame1 animated-frame">
                    Admissions requirements are outlined on a program’s web page. For most HBS Executive Education programs, participants should have at least 10 years of professional work experience and be sponsored by their current employers. You can learn more about our admissions requirements here.
                    </div>
                    <LastMenu id={3} />
                </>
            )}

            {showFrame2 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                    <div className="frame2 animated-frame">
                    Visa Requirements
                    </div>
                    </div>

                    <div className='chatbot'>
                    <img src={bot} alt="bot" className="bot" />
                    <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                    </div>
                    <div className="frame1 animated-frame">
                    Most participants who are not U.S. citizens or residents will need a non-immigrant 90-day B-1/B-2 visa to attend our programs in the United States. You can learn more about visa requirements here.
                   </div>
                    <LastMenu id={3} />
                </>
            )}

            {showFrame3 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                    <div className="frame2 animated-frame">
                    Application Process
                    </div>
                    </div>

                    <div className='chatbot'>
                    <img src={bot} alt="bot" className="bot" />
                    <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                    </div>
                    <div className="frame1 animated-frame">
                    Applications can be submitted online. Once you have applied, you can track the status of your application through the My Account application portal.
                    </div>
                    <LastMenu id={3} />
                </>
            )}

            {showFrame4 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                    <div className="frame2 animated-frame">
                    Application Assistance
                    </div>
                    </div>

                    <div className='chatbot'>
                    <img src={bot} alt="bot" className="bot" />
                    <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                    </div>
                    <ApplicationAssist />
                </>
            )}

            {showFrame5 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                <div className="frame2">Restart the chat</div>
                </div>

                <div className='chatbot'>
                <img src={bot} alt="bot" className="bot" />
                <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                </div>
                    <Mainmenu />
                </>
            )}



        </>
    );
}

export default Admissions;